import React from "react";
import "../styles/mresultheader.css";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";

import { RaceDTO } from "../../../interfaces/RaceDTO";
import { ViewType } from "../../../interfaces/internal/ViewProps";
import { useBlade } from "../../../services/BladeProvider";
import { showMenuChoice } from "../../../services/menuUpSet";
import MobileResultTabs from "./MobileResultTabs";
interface Props {
  race: RaceDTO | null;
  classChanged: (
    classID: number,
    level: number,
    maximized: boolean,
    fullheight: boolean
  ) => void;
  opennewChanged: (
    viewdat: ViewType,
    maximized: boolean,
    fullheight: boolean
  ) => void;
  onOpenModal: () => void;
}
const MobileResultHeader = ({
  classChanged,
  race,
  opennewChanged,
  onOpenModal,
}: Props) => {
  const {
    blades,
    clearBlades,
    changeBladesizeAll,
    getUserType,
    maximizeAllBlade,
  } = useBlade();

  const openNewClick = (typ: ViewType) => {
    opennewChanged(typ, true, true);
  };
  const closeAllClick = () => {
    clearBlades(true);
    // sizeChanged(maximize);
  };
  const opentvposClick = (clid: number) => {
    classChanged(clid, 1, false, true);
    // eventBus.emit(`class`, clid);
  };
  const usrType = getUserType();
  if (usrType == null) {
    return <></>;
  }
  return (
    <div className="mobile-result-header-text">
      <Navbar collapseOnSelect expand="lg" variant="dark">
        <Navbar.Brand>
          <MobileResultTabs race={race} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav>
            <Nav.Link
              id="addlist"
              onClick={() => openNewClick(ViewType.result)}
            >
              Add list
            </Nav.Link>
            {usrType.valueOf() < 31 ? (
              <Nav.Link
                id="addlistpre"
                onClick={() => openNewClick(ViewType.resultPretime)}
              >
                Add list with pretime
              </Nav.Link>
            ) : null}
            <Nav.Link
              id="addscroll"
              onClick={() => openNewClick(ViewType.scroll)}
            >
              Add scroll
            </Nav.Link>
            <Nav.Link
              id="addbios"
              onClick={() => openNewClick(ViewType.athletebio)}
            >
              Add bios
            </Nav.Link>
            {usrType.valueOf() < 5 ? (
              <Nav.Link
                id="addbiosTV"
                onClick={() => openNewClick(ViewType.athletebioTV)}
              >
                Add bios auto follow(TV)
              </Nav.Link>
            ) : null}
            {showMenuChoice(race, ViewType.shooting) ? <Nav.Link
              id="addshooting"
              onClick={() => openNewClick(ViewType.shooting)}
            >
              Add shooting
            </Nav.Link> : null}
            {showMenuChoice(race, ViewType.stage) ? <Nav.Link
              id="addsprint"
              onClick={() => openNewClick(ViewType.stage)}
            >
              Add sprint bracket
            </Nav.Link> : null}
            <Nav.Link
              id="addanalys"
              onClick={() => openNewClick(ViewType.resultAnalytics)}
            >
              Add analyslist
            </Nav.Link>
            <Nav.Link
              id="addanalys"
              onClick={() => openNewClick(ViewType.teamdata)}
            >
              Add team results
            </Nav.Link>
            <Nav.Link
              id="addSpeakerView"
              onClick={() => openNewClick(ViewType.speakerView)}
            >
              Add speakerview
            </Nav.Link>
            {usrType.valueOf() < 31 ?
              <NavDropdown title="Predfined setup" id="collasible-nav-dropdown">
                {race?.Class && usrType.valueOf() < 31 &&
                  Object.keys(race?.Class).map((key) => (
                    <NavDropdown.Item
                      key={key}
                      data-class={key}
                      onClick={() => opentvposClick(parseInt(key))}
                    >
                      {race?.Class[parseInt(key)].Name}
                    </NavDropdown.Item>
                  ))}
              </NavDropdown> : null}
            <Nav.Link onClick={closeAllClick}>Close all</Nav.Link>
            <Nav.Link onClick={() => onOpenModal()}>Change usertype</Nav.Link>
            <Nav.Link href="/">Home</Nav.Link>
          </Nav>

        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default MobileResultHeader;

// <div>
//          <div className="mobile-result-header-text">
//         <span id="event-name" className="mobile-result-header-event-name">
//           {race?.Name}
//         </span>
//         <span id="event-place" className="mobile-result-header-event-place">
//           {race?.Place}
//         </span>
//       </div>
//     </div>

// <Nav className="mr-auto">
// <Nav.Link href="#features">Features</Nav.Link>
// <Nav.Link href="#pricing">Pricing</Nav.Link>
// <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
//   <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
//   <NavDropdown.Item href="#action/3.2">
//     Another action
//   </NavDropdown.Item>
//   <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
//   <NavDropdown.Divider />
//   <NavDropdown.Item href="#action/3.4">
//     Separated link
//   </NavDropdown.Item>
// </NavDropdown>
// </Nav>
